import sliceCreator from '../../index.jsx';
import {GET_ALL_REGIONS} from '../../../constants/index.jsx';
const _getAllRegionsAction = sliceCreator('GET_ALL_REGIONS', GET_ALL_REGIONS, 'get');

const { asyncAction: getAllRegionsAction, reducer, clearData: clearGetAllRegionsAction } = _getAllRegionsAction;

export default reducer;

export {
    getAllRegionsAction,
    clearGetAllRegionsAction
}